import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'
import { createRef } from '@vue/composition-api'

export default {
  namespaced: true,
  state: {
    studentCgpa: [],
  },
  getters: {
  },
  mutations: {
  },

  actions: {
    // eslint-disable-next-line consistent-return
    async getDataSources({ commit }, params) {
      try {
        const response = await axios.get('main-hgi/reflection/getAllByStudentId', { params })
        const { data } = response
        if (data.code === 1) {
          return data
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getOne({ commit }, params) {
      try {
        const response = await axios.get('main-hgi/reflection/getOne', { params })
        const { data } = response
        if (data.status === 200) {
          return data
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createReflectionRecommendation({ commit }, params) {
      try {
        const response = await axios.post('main-hgi/reflection', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async createFile({ commit }, params) {
      try {
        const response = await axios.post('main-hgi/reflection/uploadFile', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message, data: data.data[0] }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updatePhanAnhKienNghi({ commit }, params) {
      try {
        const response = await axios.patch('main-hgi/reflection/capNhatKienNghi', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message, data: data.data }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deletePhanAnhKienNghi({ commit }, params) {
      try {
        const response = await axios.delete('main-hgi/reflection/delete', { params })
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async downloadFile({ commit }, params) {
      try {
        const response = await axios.get('main-hgi/reflection/download', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          return data.data
        }
      } catch (e) {
        handleCatch(e)
      }
},
  },
}
